/* ============================================================================
   is-doppio-paio.js — comportamento dei due riquadri dell'upsell del secondo paio.

   PERCHE' E' UN FILE A SE'. Prima stava dentro lo snippet, quindi finiva nell'HTML di
   ogni pagina del sito (~12 KB) e non entrava mai nella cache del browser: veniva
   riscaricato identico a ogni pagina visitata. Qui si scarica una volta e resta.

   IL CATALOGO NON E' PIU' IN PAGINA. Prima lo snippet stampava ~42 KB di JSON con i
   modelli proponibili, su ogni pagina del sito, anche dove il componente non si vede
   mai. Ora quel JSON si scarica da {root}search?view=is-catalogo, e solo quando serve
   davvero: cioe' quando in carrello c'e' esattamente UN paio. Vedi is-catalogo-json.liquid.

   Il resto non cambia: stesse regole di scelta, stessi testi, stessi codici sconto,
   stesso comportamento a lettera esaurita. Le note storiche e i vincoli (Simple Bundles,
   niente ricariche, morphing di Horizon) stanno in testa a snippets/is-doppio-paio.liquid.
   ========================================================================= */
(function(){
  if (window.__isDoppioPaio) return;
  window.__isDoppioPaio = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SCARTI = 'is-proposte-scartate';
  var SVG_CESTINO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';

  function euro(c){ return (c/100).toFixed(0) + ' €'; }
  function esc(s){
    return String(s || '').replace(/[&<>"']/g, function(m){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];
    });
  }

  // Il catalogo dei modelli proponibili non e' piu' stampato in pagina: si scarica dal
  // tema la prima volta che serve, cioe' quando in carrello c'e' un paio solo. Una sola
  // richiesta per pagina: la promessa e' condivisa, e il risultato resta in memoria.
  // Anche in caso di errore __IS_CATALOGO viene comunque valorizzato (a vuoto), cosi' il
  // ridisegno non entra mai in un giro infinito.
  var catInCorso = null;
  function catalogo(){
    if (window.__IS_CATALOGO) return Promise.resolve(window.__IS_CATALOGO);
    if (!catInCorso) {
      catInCorso = fetch(ROOT + 'search?view=is-catalogo', { credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.text() : '[]'; })
        .then(function(txt){
          var dati = [];
          try { dati = JSON.parse(String(txt).trim()) || []; } catch(e){ dati = []; }
          window.__IS_CATALOGO = dati;
          return dati;
        })
        .catch(function(){ window.__IS_CATALOGO = []; return []; });
    }
    return catInCorso;
  }

  // le proposte rifiutate da Shopify — lettera finita su quel modello — non si ripropongono
  // per il resto della sessione. La chiave tiene dentro anche le iniziali: con altre lettere
  // lo stesso modello e' comprabile.
  function scarti(){
    try { return JSON.parse(sessionStorage.getItem(SCARTI) || '{}') || {}; } catch(e){ return {}; }
  }
  function scarta(chiave){
    var s = scarti();
    s[chiave] = 1;
    try { sessionStorage.setItem(SCARTI, JSON.stringify(s)); } catch(e){}
  }

  class DoppioPaio extends HTMLElement {
    connectedCallback(){
      this.codStesse = (this.dataset.codiceStesse || '').trim();
      this.codDiverse = (this.dataset.codiceDiverse || '').trim();
      this.init();
      DoppioPaio.instances.push(this);
      this.osserva();
      this.aggiorna();
    }
    disconnectedCallback(){
      if (this.mo) { this.mo.disconnect(); this.mo = null; }
      var i = DoppioPaio.instances.indexOf(this);
      if (i > -1) DoppioPaio.instances.splice(i, 1);
    }
    init(){
      var esa = this.querySelector('.is-doppio__esaurite');
      var tst = this.querySelector('.is-doppio__testi');
      if (esa) { try { window.__IS_ESAURITE = JSON.parse(esa.textContent) || {}; } catch(e){} }
      if (tst) { try { window.__IS_TESTI = JSON.parse(tst.textContent); } catch(e){} }
      this.cat = window.__IS_CATALOGO || [];
      this.t = (window.__IS_TESTI || {}).doppio_paio || {};
      this.titoloEl = this.querySelector('[data-dp-titolo]');
      this.scontoEl = this.querySelector('[data-dp-sconto]');
      this.scelteEl = this.querySelector('[data-dp-scelte]');
      this.notaEl = this.querySelector('[data-dp-nota]');
      this.carrelloLabel = this.querySelector('[data-dp-carrello-label]');
      this.carrelloCorpo = this.querySelector('[data-dp-carrello-corpo]');
      this.frecciaSx = this.querySelector('[data-dp-sx]');
      this.frecciaDx = this.querySelector('[data-dp-dx]');
      this.divTitolo = this.querySelector('[data-dp-div-titolo]');
      this.divTesto = this.querySelector('[data-dp-div-testo]');
      this.divCta = this.querySelector('[data-dp-div-cta]');
      if (!this.scelteEl || !this.titoloEl) return false;
      var self = this;
      if (this.frecciaSx) this.frecciaSx.onclick = function(){ self.scorri(-1); };
      if (this.frecciaDx) this.frecciaDx.onclick = function(){ self.scorri(1); };
      this.scelteEl.onscroll = function(){ self.frecce(); };
      return true;
    }
    osserva(){
      var self = this;
      if (this.mo) return;
      this.mo = new MutationObserver(function(){
        if (!self.scelteEl || !self.contains(self.scelteEl)) {
          if (self.init()) self.aggiorna();
        }
      });
      this.mo.observe(this, { childList: true, subtree: true });
    }
    scorri(verso){
      var passo = Math.max(160, Math.round(this.scelteEl.clientWidth * 0.75));
      this.scelteEl.scrollBy({ left: verso * passo, behavior: 'smooth' });
    }
    frecce(){
      if (!this.frecciaSx || !this.frecciaDx) return;
      var el = this.scelteEl;
      var scorrevole = el.scrollWidth > el.clientWidth + 4;
      this.frecciaSx.hidden = !scorrevole || el.scrollLeft <= 4;
      this.frecciaDx.hidden = !scorrevole || (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4);
    }
    aggiorna(){
      var self = this;
      fetch(ROOT + 'cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c) self.render(c); })
        .catch(function(){});
    }
    rimuovi(key){
      var R = window.ISRegolePackaging;
      R.scrivi('cart/change.js', { id: key, quantity: 0 })
        .then(function(risp){ if (!R.applica(risp)) window.location.reload(); })
        .catch(function(){});
    }
    render(cart){
      if (!this.scelteEl || !this.contains(this.scelteEl)) { if (!this.init()) return; }
      var R = window.ISRegolePackaging;
      if (!R) { this.hidden = true; return; }
      var s = R.stato(cart);

      // si mostra solo con UN paio: da due in su tocca al confezionamento, sotto il riepilogo
      if (s.paia !== 1) { this.hidden = true; return; }

      var ini = s.elenco[0].ini, item = s.elenco[0].item;
      if (!ini.nomeSx || !ini.nomeDx) { this.hidden = true; return; }
      var self = this;

      /* ---------- Design Edition: su una calza c'e' un disegno, non una lettera ----------
         Su questi modelli il cliente sceglie il ricamo per la calza sinistra ("Racchette
         Tennis Ricamo Verde") e la lettera per la destra ("- A -"). Il codice che legge le
         iniziali prende la prima lettera di ogni valore, e da "Racchette..." tira fuori una
         "R": l'invito diventava «aggiungi un paio con le iniziali R-A», che non vuol dire
         niente, perche' la sinistra non e' un'iniziale.
         Regola (28/08/2026, decisa da Luca): con un disegno in carrello NON si propone il
         secondo paio con le stesse iniziali al 10%. Resta solo l'invito ad aggiungere un
         paio con ALTRE iniziali al 5%, che sta nel riquadro sotto.
         Come si riconosce: si tolgono spazi e segni dal valore scelto; se resta UNA sola
         lettera e' un'iniziale, se ne restano molte e' il nome di un disegno. Non dipende
         dalla lingua, quindi vale anche sul sito in inglese, tedesco, francese e spagnolo. */
      var conDisegno = (function(){
        var p = item.properties || {}, trovato = false;
        function unaLetteraSola(v){
          return String(v || '').replace(/[^A-Za-z\u00C0-\u017F]/g, '').length === 1;
        }
        Object.keys(p).forEach(function(k){
          var K = k.toUpperCase();
          if (K.indexOf('BUNDLE_SELECTION') > -1) return;
          if (K.indexOf('SINISTRA') > -1 || K.indexOf('LEFT') > -1 ||
              K.indexOf('DESTRA') > -1 || K.indexOf('RIGHT') > -1) {
            if (!unaLetteraSola(p[k])) trovato = true;
          }
        });
        return trovato;
      })();

      // da qui in poi serve il catalogo, che non e' piu' in pagina: se non c'e' ancora lo
      // si scarica e si ridisegna. Una sola volta: dopo il fetch __IS_CATALOGO esiste sempre.
      if (!window.__IS_CATALOGO) { catalogo().then(function(){ self.render(cart); }); return; }
      this.cat = window.__IS_CATALOGO;

      var proposte = (window.ISProposte && window.ISProposte.scegli)
        ? window.ISProposte.scegli(this.cat, item) : [];
      var fuori = scarti();
      proposte = proposte.filter(function(p){ return !fuori[p.variante + '|' + ini.chiave]; });

      if (this.carrelloLabel) this.carrelloLabel.textContent = this.t.carrello || '';
      if (this.carrelloCorpo) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
        this.carrelloCorpo.innerHTML =
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') +
          '<span class="is-doppio__incarrello-testo">' +
            '<b>' + esc(this.nomeBreve(item.product_title || item.title)) + '</b>' +
            '<span class="dp-ini">' + esc(ini.etichetta || (ini.sx + '-' + ini.dx)) + '</span> · ' + euro(item.original_line_price || item.final_line_price) +
          '</span>';
        var cest = document.createElement('button');
        cest.type = 'button';
        cest.className = 'is-doppio__cestino';
        cest.setAttribute('aria-label', (this.t.rimuovi || 'Rimuovi') + ' ' + (item.product_title || ''));
        cest.innerHTML = SVG_CESTINO;
        cest.addEventListener('click', function(){ self.rimuovi(item.key); });
        this.carrelloCorpo.appendChild(cest);
      }

      // con un disegno in carrello resta solo il riquadro "altre iniziali": niente 10%
      var carosello = this.querySelector('.is-doppio__carosello');
      if (conDisegno) {
        this.titoloEl.hidden = true;
        if (this.scontoEl) this.scontoEl.hidden = true;
        if (carosello) carosello.hidden = true;
      } else {
        this.titoloEl.hidden = false;
        if (this.scontoEl) this.scontoEl.hidden = false;
        this.titoloEl.innerHTML = String(this.t.titolo || '')
          .replace(/%iniziali%/g, ini.sx + '-' + ini.dx);
        if (this.scontoEl) this.scontoEl.innerHTML = this.t.sconto || '';
      }

      // il carosello puo' essere vuoto (nessun modello compatibile): in quel caso resta il
      // solo invito per le iniziali diverse, che vale sempre
      this.scelteEl.innerHTML = '';
      (conDisegno ? [] : proposte).forEach(function(p, i){
        var card = document.createElement('div');
        card.className = 'is-doppio__card';
        var carica = i < 4 ? 'eager' : 'lazy';
        card.innerHTML =
          (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="' + carica + '" decoding="async">' : '') +
          '<span class="dp-nome">' + esc(self.nomeBreve(p.titolo)) + '</span>' +
          '<span class="dp-prezzo">' + euro(p.prezzo) + '</span>';
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = self.t.aggiungi || 'Aggiungi';
        b.addEventListener('click', function(){ self.aggiungi(p, ini, card); });
        card.appendChild(b);
        self.scelteEl.appendChild(card);
      });
      this.querySelector('.is-doppio__carosello').hidden = conDisegno || !proposte.length;

      if (this.divTitolo) this.divTitolo.innerHTML = this.t.diverse_titolo || '';
      if (this.divTesto) this.divTesto.innerHTML = this.t.diverse_testo || '';
      if (this.divCta) {
        this.divCta.textContent = this.t.diverse_cta || '';
        // porta alle collezioni del genere che sta comprando, non alla scheda gia' vista
        this.divCta.href = R.paginaCollezioni(cart);
      }

      // un messaggio appena mostrato resta a schermo: il ridisegno che segue un tentativo
      // fallito lo cancellava prima che il cliente potesse leggerlo
      if (!this.notaFinoA || Date.now() > this.notaFinoA) this.notaEl.hidden = true;
      this.hidden = false;
      requestAnimationFrame(function(){ self.frecce(); });
    }
    nomeBreve(t){
      return String(t || '')
        .replace(/^Calze\s+(Uomo|Donna|Unisex)\s*/i,'')
        .replace(/\s*\|\s*Taglia.*$/i,'')
        .replace(/\s*\|\s*Lunghezza.*$/i,'')
        .trim();
    }
    // aggiunge il secondo paio con le stesse lettere e applica lo sconto, senza ricaricare
    aggiungi(p, ini, card){
      var self = this, R = window.ISRegolePackaging;
      Array.prototype.forEach.call(this.scelteEl.querySelectorAll('button'), function(b){ b.disabled = true; });
      this.notaFinoA = 0;
      this.notaEl.hidden = false;
      this.notaEl.textContent = this.t.corso || '...';
      var props = {};
      props[ini.nomeSx] = '- ' + ini.sx + ' -';
      props[ini.nomeDx] = '- ' + ini.dx + ' -';
      props[ini.nomeBundle || '_bundle_selection'] = ini.bundle || ('- ' + ini.sx + ' - <> - ' + ini.dx + ' -');

      R.scrivi('cart/add.js', { items: [{ id: p.variante, quantity: 1, properties: props }] })
        .then(function(){
          if (!self.codStesse) return null;
          return R.scrivi('cart/update.js', { discount: self.codStesse });
        })
        .then(function(ultima){
          if (!R.applica(ultima)) window.location.reload();
        })
        .catch(function(errore){
          Array.prototype.forEach.call(self.scelteEl.querySelectorAll('button'), function(b){ b.disabled = false; });
          // capita: quella lettera e' esaurita su quel modello. Shopify lo dice, e lo diciamo
          // anche noi; poi la proposta sparisce e resta fuori, perche' riproporla darebbe lo
          // stesso esito — ma solo per queste due lettere
          self.notaEl.textContent = (errore && errore.motivo) ? errore.motivo : (self.t.errore || 'Riprova');
          self.notaEl.hidden = false;
          self.notaFinoA = Date.now() + 8000;
          if (errore && errore.motivo) {
            scarta(p.variante + '|' + ini.chiave);
            if (card && card.parentNode) card.parentNode.removeChild(card);
            if (!self.scelteEl.children.length) {
              self.querySelector('.is-doppio__carosello').hidden = true;
            }
            requestAnimationFrame(function(){ self.frecce(); });
          }
        });
    }
  }
  DoppioPaio.instances = [];
  if (!customElements.get('doppio-paio')) customElements.define('doppio-paio', DoppioPaio);

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var t = null;
  function soon(){
    clearTimeout(t);
    t = setTimeout(function(){ DoppioPaio.instances.forEach(function(x){ x.aggiorna(); }); }, 200);
  }
  var _f = window.fetch;
  if (_f) window.fetch = function(input){
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var pr = _f.apply(this, arguments);
    if (CART_WRITE.test(u)) pr.then(soon).catch(function(){});
    return pr;
  };
  ['cart:updated','cart:refresh','cart:change','cart:update','cart-drawer:open'].forEach(function(e){ document.addEventListener(e, soon); });
  document.addEventListener('shopify:section:load', soon);
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) soon(); });
  window.addEventListener('pageshow', soon);
})();
